import { Book, MapPin } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Text } from "~/components/text";
import { SubjectsList } from "./subjects-list";
import { QualifiersList } from "./qualifiers-list";

export const Codes = ({ variant }: { variant?: "database" | "generated" }) => {
  const { t } = useTranslation(["productDetails"]);

  return (
    <>
      <div className="flex items-center gap-x-2 px-5 py-1 bg-secondary-25">
        <Book className="size-3.5" />
        <Text as="span" variant="detail">
          {t("thema.headers.subjects")}
        </Text>
      </div>
      <SubjectsList variant={variant} />
      <div className="flex items-center gap-x-2 px-5 py-1 bg-secondary-25">
        <MapPin className="size-3.5" />
        <Text as="span" variant="detail">
          {t("thema.headers.qualifiers")}
        </Text>
      </div>
      <QualifiersList variant={variant} />
    </>
  );
};
